import { maskPIIFullStory } from './maskPIIFullStory';

export const partialPIIMask = (label: string, piiString: string): React.ReactNode[] => {
  return label.split(piiString).reduce<React.ReactNode[]>((result, str, index, splits) => {
    result.push(str);
    if (index !== splits.length - 1) {
      result.push(maskPIIFullStory(piiString, `${piiString}-${index}`));
    }
    return result;
  }, []);
};
